import { CloseCircleOutlined } from "@ant-design/icons";
import { AgGridReactProps } from "ag-grid-react";
import { Button, Card, Checkbox, Col, message, Pagination, Row } from "antd";
import Title from "antd/es/typography/Title";
import { AxiosError } from "axios";
import React, { ReactNode, useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { match } from "ts-pattern";

import { leaseService, maintenanceService } from "../../../../configs/constants";
import { useGetPaymentTypeOptions } from "../../../../hooks/useGetPaymentTypeOptions";
import { OwnerFilterConfig, OwnerSelectOption, useGetOwners } from "../../../../hooks/useGetOwners";
import { useGridReset } from "../../../../hooks/useGridReset";
import { SelectOption } from "../../../../types/select";
import axios from "../../../../utils/axiosInceptor";
import { dateByformat } from "../../../../utils/dateHelper";
import { getGridSettings } from "../../../../utils/globalService";
import { isReceiptsModuleEnabled } from "../../../../utils/isReceiptsModuleEnabled";
import { AppButton } from "../../../atoms/Button";
import Grid from "../../../atoms/Grid";
import DragAndDropList from "../../../atoms/Grid/gridColumnSort";
import { Popup, PopupTitle } from "../../../atoms/Popup";
import { DATE_FORMATS, formatCurrency } from "../../../libs/utils";
import DashboardLayout from "../../../molecules/DashboardLayout";
import { DocumentViewer } from "../../../molecules/Documents";
import SectionHeader from "../../../molecules/SectionHeader";
import SideDrawer from "../../../molecules/SideDrawer";
import { Modal } from "../../BookingForm/components";
import Loader from "../../Loader.tsx";
import { getOrgByID } from "../../Maintenance/Tickets/ducks/actions";
import { getPropertiesDrop } from "../../Properties/ducks/actions";
import { paymentModes, paymentStatus, sendStatusOptions, usageTypeOptions } from "../../Properties/ducks/constants";
import { emptyPropertyUnits, getPropertyUnits } from "../../Properties/PropertyDetail/ducks/actions";
import { getOnePDC, getPDC, updatePDCStatus } from "../ducks/actions";
import { paymentModeOptions } from "../utili";
import AdditionalFilters from "./AdditionalFilters";
import { useGenerateTorRequest, useSendInvoiceRequest } from "./api";
import { ApplyCreditNote } from "./ApplyCreditNote";
import { useRejectBankTransfer } from "./ApplyCreditNote/api";
import CreditCardRequest from "./CreditCardRequest/CreditCardRequest";
import ModifyPaymentStatus from "./ModifyPaymentStatus";
import ReceivePaymentMultiInvoice from "./ReceiptMultiInvoiceAllocation/ReceivePaymentMultiInvoice";
import ChequeClearModal from "./ModifyPaymentStatus/ChequeClearModal";
import DeferChequeDeposit from "./ModifyPaymentStatus/DeferChequeDeposit";
import { columnDefs, pdcColumn } from "./pdcColumn";
import { RecallCheque } from "./RecallCheque";
import { ReceiptConfirmation } from "./ReceiptConfirmation";
import { SendInvoicesConfirm } from "./SendInvoicesConfirm";
import { TorLedger } from "./TorLedger";
import { Invoice } from "./types";
import ViewPayment from "./ViewPayAttachment/ViewPayment";
import { GridType } from "../../../../types/grid";
import { useGetOrganization } from "../../../../api/v1";

var _ = require("lodash");

type PropertyOption = {
  name: string;
  label: string;
  search?: boolean;
  allowClear?: boolean;
  initialValue: string;
  options: SelectOption[];
  dropdownRender?: (children: ReactNode) => ReactNode;
};

const defaultSettings = {
  sortable: true,
  resizable: true,
  minWidth: 200,
};

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const allUsageTypeOpt: SelectOption = { label: "All", value: "all" };
const pdcUsageTypeOptions: SelectOption[] = [allUsageTypeOpt, ...usageTypeOptions];
const defaultUsageType = allUsageTypeOpt.value;
const defaultSendStatus = sendStatusOptions[0]?.value;
const defaultPaymentTypeOpt: SelectOption = { label: "All", value: "all" };

// Invoice screen exposes only these payment status values.
const invoicePaymentStatusOptions: SelectOption[] = [
  { label: "All", value: "all" },
  { label: "Paid", value: "paid" },
  { label: "Pending", value: "pending" },
  { label: "Cancelled", value: "cancelled" },
];

type PdcListRow = Invoice & { _id?: string };

const rowPdcId = (row: PdcListRow | undefined) => String(row?.pdcId ?? row?._id ?? "");

export default React.memo((_props) => {
  const { organization } = useGetOrganization();
  const receiptsEnabled = isReceiptsModuleEnabled(organization);
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("pdcId");
  const { resetGrid, setGridReset } = useGridReset();
  const dispatch: any = useDispatch();
  let query = useQuery();
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = React?.useState("");
  const [page, setPage] = useState(1);
  const [limit, _setLimit] = useState(50);
  const [paymentStatusInfo, setPaymentStatusInfo] = useState(null);
  const [selectedPdcIds, setSelectedPdcIds] = useState<string[]>([]);
  const [pendingSendInvoices, setPendingSendInvoices] = useState<PdcListRow[]>([]);
  const [sendInvoicesModalOpen, setSendInvoicesModalOpen] = useState(false);
  const [_pdcList, setPdcList] = useState([]);
  const [resetOwner, setResetOwner] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [receiptNoFilter, setReceiptNoFilter] = useState<string | null>(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedUsageType, setSelectedUsageType] = useState(defaultUsageType);
  const [selectedSendStatus, setSelectedSendStatus] = useState(null);
  const [status, setStatus] = useState("all");
  // for story 8503
  const [selectPaymentMode, setPaymentMode] = useState(null);
  const [selectPaymentType, setPaymentType] = useState(null);
  let initialState = {
    modalPayload: {
      iKey: "",
      title: "",
      open: false,
      extraText: "",
      screen: "payment",
    },
  };
  const [{ modalPayload }, setState] = useState(initialState);
  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));

  const [ownerId, setOwnerId] = useState("");
  const [_isRequestLoading, setIsRequestLoading] = useState(false);
  const [showAll, setShowAll] = useState(true);
  const [updateValue, setUpdateValue] = useState({});
  const [visible, setVisible] = useState({ status: false, index: 1 });

  const [selectedPDCs, setSelectedPDC] = useState(null);
  const [creditNoteAction, setCreditNoteAction] = useState<"apply" | "approveReject">("apply");
  const [recallChequeActionType, setRecallChequeActionType] = useState<"apply" | "approveReject">("apply");
  const [pendingApprovalRecordsCount, setPendingApprovalRecordsCount] = useState(0);
  const [pendingCreditCardRecordsCount, setPendingCreditCardRecordsCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [dateTo, setDateTo] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState<string | null>(null);
  // for story 11530 sprint 48
  const [chequeDateFrom, setChequeDateFrom] = useState(null);
  const [chequeDateTo, setChequeDateTo] = useState(null);
  const [bankRefFilter, setBankRefFilter] = useState(null);
  const [tenantNameFilter, setTenantNameFilter] = useState(null);
  const [paymentRefFilter, setPaymentRefFilter] = useState(null);
  const [erpInvoiceNumberFilter, setErpInvoiceNumberFilter] = useState(null);
  const [erpTenantIdFilter, setErpTenantIdFilter] = useState(null);
  const [erpReceiptsFilter, setErpReceiptsFilter] = useState(null);
  const [drawer, setDrawer] = useState(false);
  const [paymentColumns, setPaymentsColumns] = useState<GridType[]>([]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const [exportData, setExportData] = useState(false);
  const [isCleared, setIsCleared] = useState(null);
  const [isPendingRequestsFilter, setIsPendingRequestsFilter] = useState(() => Boolean(paymentId));

  const { owners } = useGetOwners();

  const ownerFilterOptions = useMemo<OwnerFilterConfig[]>(() => {
    const defaultOptions: OwnerSelectOption[] = [{ value: "All Owners", label: "All Owners", a: "" }];
    const options = owners.length > 0 ? owners : defaultOptions;
    return [
      {
        name: "ownerId",
        label: `Owner (${Math.max(options.length - 1, 0)})`,
        placeholder: "All Owners",
        defaultValue: "All Owners",
        options,
      },
    ];
  }, [owners]);

  const paymentTypeUsageType = selectedUsageType === "all" ? null : selectedUsageType;
  const { paymentTypesOptions } = useGetPaymentTypeOptions({ usageType: paymentTypeUsageType || undefined });
  const units = useSelector((state: any) => state.propertyDetails.unitsDropdown);
  const { sendInvoiceRequest, isPendingSendInvoiceRequest } = useSendInvoiceRequest({
    onSuccess: () => {
      message.success("Invoice(s) sent successfully");
      getPDCList();
      setSelectedPdcIds([]);
      setPendingSendInvoices([]);
      setSendInvoicesModalOpen(false);
    },
    onError: () => message.error("Failed to send invoice(s)"),
  });

  const { generateTorRequest, isPendingGenerateTorRequest } = useGenerateTorRequest({
    onError: () => message.error("Failed to submit invoice generation request"),
  });
  const { rejectBankTransferRequest } = useRejectBankTransfer({
    onSuccess: (data) => {
      getPDCList();
      message.success(data?.message || "Bank transfer rejected successfully");
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        message.error(error?.response?.data?.error || "Failed to reject bank transfer");
      }
    },
  });

  const getGridConfig = async () => {
    // If receipts module is disabled, keep invoicing columns unchanged.
    if (!receiptsEnabled) {
      const result = await getGridSettings("payment", columnDefs, resetGrid);
      setPaymentsColumns(result);
      setGridReset(false);
      return;
    }
    // Receipts-enabled: adjust invoice columns/selector only.
    const removedFields = new Set([
      "deferredDate",
      "modeOfPayment",
      "bankName",
      "documentNo",
      "chequeDate",
      "reason",
      "Attachments",
      "depositDate",
      "isCleared",
      "beneficiaryName",
      "beneficiaryBank",
      "beneficiaryAccount",
      "beneficiaryIBAN",
      "lessorName",
      // "ownerName",
    ]);

    const modifiedColumnDefs = (columnDefs ?? [])
      .filter((c: any) => c?.field && !removedFields.has(c.field))
      .map((c: any) => {
        if (c.field === "chequeStatus") return { ...c, headerName: "Invoice Status" };
        return c;
      });

    const result = await getGridSettings("payment", modifiedColumnDefs as any, resetGrid);

    // Reconcile persisted config against modified defs, so changes reflect immediately.
    const baseByField = new Map((modifiedColumnDefs ?? []).map((c: any) => [c?.field, c]));
    const normalized = (Array.isArray(result) ? result : [])
      .filter((c: any) => c?.field && baseByField.has(c.field))
      .map((c: any) => {
        const base = baseByField.get(c.field);
        return base ? { ...base, ...c, headerName: c.headerName ?? base.headerName } : c;
      });

    setPaymentsColumns(normalized);
    setGridReset(false);
  };

  useEffect(() => {
    getGridConfig();
  }, [resetGrid, receiptsEnabled]);

  // Receipts-enabled: update only the invoice header filters (Payment Status options, remove Payment Mode filter).
  useEffect(() => {
    if (!receiptsEnabled) return;
    setPropertyOptions((prev) =>
      prev
        .filter((opt) => opt.name !== "Payment Mode")
        .map((opt) => (opt.name === "status" ? { ...opt, options: invoicePaymentStatusOptions } : opt)),
    );
  }, [receiptsEnabled]);

  useLayoutEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width >= 1500) {
        setScreenSize("xl");
      } else if (width >= 992) {
        setScreenSize("lg");
      } else {
        setScreenSize("smaller than lg");
      }
    };

    // Initial check
    checkScreenSize();
    // Add event listener to update on resize
    window.addEventListener("resize", checkScreenSize);
    // Clean up the event listener on unmount
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const orgId = JSON.parse(localStorage?.getItem("login-response"));
  const [gracePeriodDays, setGracePriodDays] = useState(null);

  const getOrgByIDForPayments = useMemo(
    () => async () => {
      if (!orgId?.orgId) return; // Prevent unnecessary calls
      if (orgId && orgId?.orgId) {
        dispatch(getOrgByID(orgId?.orgId));
      }
      try {
        const data = await axios.get(`${maintenanceService}/organization/${orgId?.orgId}`);
        setGracePriodDays(data?.data?.result?.dayForPaynowbtnBeforeDueDate);
      } catch (e) {
        if (e instanceof Error) {
          message.error(e?.message || "Failed to fetch organization details");
        }
      }
    },
    [orgId?.orgId],
  ); // Memoize based on orgId change

  useEffect(() => {
    orgId?.orgId && getOrgByIDForPayments();
  }, [orgId?.orgId]);

  const PDCApi = useSelector((state: any) => state.contracts.pdcList);
  const properties = useSelector((state: any) => state.dashboard.propertiesDrop);

  useEffect(() => {
    if (query.get("pdcId")) {
      (async () => {
        setIsRequestLoading(true);
        const pdc = await getOnePDC(query.get("pdcId"));
        if (pdc?.status === 200 && pdc?.data?.result?.creditCardRequest === "pending") {
          setShowAll(false);
          setVisible({ status: true, index: 1 });
        }
      })();
    }
  }, [query.get("pdcId")]);

  const defaultPropertyOpt = {
    label: "All Properties",
    value: "",
  };

  const defaultUnitOpt = {
    label: "All Units",
    value: "",
  };

  const [isDraftIncluded, setIsDraftIncluded] = useState(false);

  const paymentTypeFilterOptions = useMemo<SelectOption[]>(() => {
    if (paymentTypesOptions.some((option) => option.value === defaultPaymentTypeOpt.value)) return paymentTypesOptions;
    return [defaultPaymentTypeOpt, ...paymentTypesOptions];
  }, [paymentTypesOptions]);

  const [propertyOptions, setPropertyOptions] = useState<PropertyOption[]>([
    {
      name: "usageType",
      label: "Usage Type",
      initialValue: defaultUsageType,
      options: pdcUsageTypeOptions,
    },
    {
      name: "property",
      label: "Property",
      search: true,
      initialValue: "",
      options: [defaultPropertyOpt],
    },
    {
      name: "unit",
      label: "Unit",
      search: true,
      initialValue: "",
      options: [],
    },
    {
      name: "status",
      label: "Payment Status",
      initialValue: "All",
      options: paymentStatus,
    },
    {
      name: "Payment Mode",
      label: "Payment Modes",
      initialValue: "All",
      options: paymentModes,
    },
    {
      name: "Payment Type",
      label: "Payment Type",
      initialValue: "All",
      options: paymentTypeFilterOptions,
    },
    {
      name: "sendStatus",
      label: "Send Status",
      initialValue: "all",
      allowClear: true,
      options: sendStatusOptions,
    },
  ]);

  useEffect(() => {
    if (PDCApi?.data?.length > 0) {
      setPdcList(PDCApi?.data);
    } else {
      setPdcList(null);
    }
  }, [PDCApi, status, exportData]);

  const paymentStatusFilterDropdownRender = useCallback(
    (children: ReactNode): ReactNode => (
      <>
        {children}
        <Checkbox
          style={{ padding: 10 }}
          checked={isDraftIncluded}
          onChange={(e) => setIsDraftIncluded(e.target.checked)}
        >
          Include Draft
        </Checkbox>
      </>
    ),
    [isDraftIncluded],
  );

  useEffect(() => {
    const finalUnitOptions = units?.length ? units : [];

    setPropertyOptions((prev) =>
      prev.map((opt) =>
        match(opt.name)
          .with("property", () => ({ ...opt, options: [defaultPropertyOpt, ...properties] }))
          .with("unit", () => ({ ...opt, options: [defaultUnitOpt, ...finalUnitOptions] }))
          .with("Payment Type", () => ({ ...opt, options: paymentTypeFilterOptions }))
          .with("status", () => ({ ...opt, dropdownRender: paymentStatusFilterDropdownRender }))
          .otherwise(() => opt),
      ),
    );

    if (properties.length === 0) {
      dispatch(getPropertiesDrop());
    }
  }, [properties, units, paymentStatusFilterDropdownRender, paymentTypeFilterOptions]);

  useEffect(() => {
    dispatch(getPropertyUnits(selectedProperty?.propertyId, false, true));
    return () => dispatch(emptyPropertyUnits());
  }, [selectedProperty]);

  const buildPdcParams = useCallback(
    (options: { exportData?: unknown } = {}) => {
      const params: Record<string, unknown> = {};
      if (paymentId) params["pdcId"] = paymentId;

      if (selectedUsageType && selectedUsageType !== "all") params["usageType"] = selectedUsageType;
      if (selectedSendStatus && selectedSendStatus !== defaultSendStatus) params["sendStatus"] = selectedSendStatus;
      if (selectedProperty?.propertyId) params["propertyId"] = selectedProperty?.propertyId;
      if (selectedUnit) params["unitId"] = selectedUnit;
      if (status) params["chequeStatus"] = status;
      if (ownerId?.trim()) params["ownerId"] = ownerId.trim();
      if (selectPaymentMode?.value) params["paymentMode"] = selectPaymentMode?.value;
      if (selectPaymentType?.value) params["paymentType"] = selectPaymentType?.value;
      if (dateFrom) params["startDueDate"] = dateByformat(dateFrom, DATE_FORMATS.api);
      if (dateTo) params["endDueDate"] = dateByformat(dateTo, DATE_FORMATS.api);
      if (chequeDateFrom) params["chequeDateFrom"] = dateByformat(chequeDateFrom, DATE_FORMATS.api);
      if (chequeDateTo) params["chequeDateTo"] = dateByformat(chequeDateTo, DATE_FORMATS.api);
      if (bankRefFilter) params["bankName"] = bankRefFilter;
      if (paymentRefFilter) params["paymentRefNo"] = paymentRefFilter;
      if (tenantNameFilter) params["tenantName"] = tenantNameFilter;
      if (erpInvoiceNumberFilter) params["erpInvoiceNumber"] = erpInvoiceNumberFilter;
      if (erpTenantIdFilter) params["erpTenantId"] = erpTenantIdFilter;
      if (erpReceiptsFilter) params["erpReceipts"] = erpReceiptsFilter;
      if (options?.exportData) {
        let checkedColumns = paymentColumns
          .filter((col) => col.checked && col.headerName !== "Actions")
          .map((col) => col.headerName)
          .join(", ");

        params["columns"] = checkedColumns;
        params["exportData"] = options.exportData;
        params["totalCount"] = PDCApi?.totalCount;
      }
      if (isDraftIncluded) params["isStatusDraftIncluded"] = isDraftIncluded ? "yes" : "no";
      if (invoiceNumber) params["invoiceNumber"] = invoiceNumber;
      if (receiptNoFilter) params["receiptNo"] = receiptNoFilter;
      if (isPendingRequestsFilter) {
        params["deferredRequest"] = "pending";
        params["creditNoteRequest"] = "pending";
        params["recallChequeRequest"] = "pending";
        params["receiptApprovalRequest"] = "pending";
      }
      if (isCleared === "cleared") params["isCleared"] = true;
      if (isCleared === "not_cleared") params["isCleared"] = false;

      return params;
    },
    [
      selectedUsageType,
      selectedSendStatus,
      selectedProperty?.propertyId,
      selectedUnit,
      status,
      ownerId,
      selectPaymentMode?.value,
      selectPaymentType?.value,
      dateFrom,
      dateTo,
      chequeDateFrom,
      chequeDateTo,
      bankRefFilter,
      paymentRefFilter,
      tenantNameFilter,
      erpInvoiceNumberFilter,
      erpTenantIdFilter,
      erpReceiptsFilter,
      isDraftIncluded,
      invoiceNumber,
      receiptNoFilter,
      isPendingRequestsFilter,
      PDCApi?.totalCount,
      isCleared,
      exportData,
      paymentId,
    ],
  );

  const fetchPdc = useCallback(
    (options: { pageOverride?: number; exportData?: unknown } = {}) => {
      const { pageOverride = page, exportData } = options;
      setIsLoading(true);
      const params = buildPdcParams({ exportData });
      dispatch(getPDC(params, limit, pageOverride, setIsLoading, setExportData, null));
    },
    [buildPdcParams, dispatch, limit, page, paymentId],
  );

  const togglePendingRequestsFilter = () => {
    setIsPendingRequestsFilter((prev) => !prev);

    if (paymentId) {
      navigate("/invoicing", { replace: true });
    }
  };

  const fetchPendingRequests = useCallback(async () => {
    setIsRequestLoading(true);
    try {
      const url = `${leaseService}/booking/pdclist`;
      const creditCardResponse = await axios.get(url, { params: { creditCardRequest: "pending" } });

      if (creditCardResponse?.status === 200) {
        setPendingCreditCardRecordsCount(creditCardResponse?.data?.result?.totalCount || 0);
      }

      if (paymentId) {
        const invoicingResponse = await axios.get(url, { params: { pdcId: paymentId } });
        if (invoicingResponse?.status === 200) {
          setPendingApprovalRecordsCount(invoicingResponse?.data?.result?.totalCount || 0);
        }
      } else {
        setPendingApprovalRecordsCount(0);
      }
    } finally {
      setIsRequestLoading(false);
    }
  }, [paymentId]);

  useEffect(() => {
    // if (!paymentId) return;
    fetchPendingRequests();
  }, [fetchPendingRequests, paymentId]);

  const getPdcData = (exportData = false) => {
    setPdcList(null);
    setIsLoading(true);
    setPage(1);
    fetchPdc({ pageOverride: 1, exportData });
  };

  useEffect(() => {
    getPdcData();
  }, [
    selectedUsageType,
    selectedSendStatus,
    selectedProperty,
    selectedUnit,
    status,
    selectPaymentMode,
    selectPaymentType,
    dateTo,
    dateFrom,
    chequeDateTo,
    chequeDateFrom,
    bankRefFilter,
    tenantNameFilter,
    paymentRefFilter,
    erpInvoiceNumberFilter,
    erpTenantIdFilter,
    erpReceiptsFilter,
    ownerId,
    isDraftIncluded,
    invoiceNumber,
    receiptNoFilter,
    isPendingRequestsFilter,
    isCleared,
    paymentId,
  ]);

  function handlePropertyChange(property, label) {
    let selectedStatus = status;
    if (label === "usageType") {
      setSelectedUsageType(property?.value);
      setUpdateValue([
        { label: "unit", value: "" },
        { label: "Payment Type", value: "all" },
      ]);
      setPaymentType(null);
    } else if (label === "property") {
      setUpdateValue([
        { label: "unit", value: "" },
        { label: "status", value: selectedStatus },
      ]);
      setSelectedUnit(null);
      setStatus(selectedStatus);
      setSelectedProperty({
        propertyId: property?.value,
        property_name: property?.label,
      });
    } else if (label === "unit" && property?.label !== null) {
      // unit = units[property?.value];
      setSelectedUnit(property?.label === "All Units" ? "" : property?.value);
    } else if (label === "status" && property?.value !== null) {
      selectedStatus = property?.value === "all" ? null : property?.value;
      setStatus(selectedStatus);
    } else if (label === "Payment Mode") {
      property?.value === "all"
        ? setPaymentMode(null)
        : setPaymentMode({ value: property?.value, label: property?.label });
    } else if (label === "Payment Type") {
      property?.value === "all"
        ? setPaymentType(null)
        : setPaymentType({ value: property?.value, label: property?.label });
    } else if (label === "sendStatus") {
      setSelectedSendStatus(property?.value === defaultSendStatus ? null : property?.value);
    }
    setSelectedPdcIds([]);
  }

  const getPaymentMode = (key) => {
    let temp = "";
    switch (key) {
      case "Cheque":
        temp = "cheque";
        break;
      case "Credit Card":
        temp = "credit_card";
        break;
      case "Bank Transfer":
        temp = "bank_transfer";
        break;
      case "Cash":
        temp = "cash";
        break;
      default:
        temp = key;
        break;
    }

    return temp;
  };

  const onUpdateCheckStatus = async (params) => {
    setIsLoading(true);
    try {
      if (params.value !== "select") {
        if (
          params.data?.modeOfPayment?.toLowerCase() === "cheque" &&
          (params.value === "bounce" || params.value === "cancelled" || params.value === "paid")
        ) {
          setPaymentStatusInfo({ paymentMode: params.data?.modeOfPayment, status: params.value, params: params });
          setVisible({ status: true, index: 2 });

          return;
        }
        await updatePDCStatus(
          {
            leaseId: params.data.leaseId,
            pdcId: params.data._id,
          },
          { [params.colDef.field]: getPaymentMode(params.value) },
        );

        fetchPdc({ pageOverride: page });
      }
    } catch (error) {
      if (error) {
        message.error(error?.response?.data?.error || "Failed to update");
      }
    }
  };

  const handlePagination = (page) => {
    setSelectedPdcIds([]);
    setIsLoading(true);
    setPdcList(null);
    setPage(page);
    fetchPdc({ pageOverride: page });
  };

  const onUpdate = () => {
    setPdcList(null);
    setIsLoading(true);
    fetchPdc({ pageOverride: page });
  };

  const getPDCList = () => {
    setIsLoading(true);
    fetchPdc({ pageOverride: page });
  };

  const onSelectionChanged: AgGridReactProps["onSelectionChanged"] = ({ api }) => {
    const pdcIds: string[] = [];

    for (const node of api.getSelectedNodes()) {
      const row = node?.data as PdcListRow | undefined;
      const id = rowPdcId(row);
      const pending = row?.chequeStatus?.toLowerCase() === "pending";
      if (pending && id) pdcIds.push(id);
    }
    if (pdcIds.length > 0) setSelectedPdcIds(pdcIds);
    else setSelectedPdcIds([]);
  };

  const onClickGenerateInvoiceOrTor = async (pdcId?: string) => {
    if (!pdcId) return;

    const response = await generateTorRequest({ pdcId });
    if (response?.success) {
      message.success("Invoice generation request submitted successfully");
      getPDCList();
    }
  };

  const onClickRejectTransfer = async (invoice?: Invoice & { leaseId?: string }) => {
    if (!invoice?.leaseId || !invoice?.pdcId) {
      message.error("Unable to reject transfer. Missing lease or invoice details");
      return;
    }

    await rejectBankTransferRequest({
      leaseId: invoice.leaseId,
      data: { pdcId: invoice.pdcId },
    });
  };

  const openPrintInvoiceModal = async (pdcId: string) => {
    if (!pdcId) return;

    const response = await generateTorRequest({ pdcId, source: "printInvoice" });

    if (!response?.result?.documentId) {
      message.info("Invoice document not found. Please generate it first");
      return;
    }

    setSelectedDocumentId(response.result.documentId);
    setVisible({ status: true, index: 4 });
  };

  const onClosePrintInvoiceModal = () => {
    setVisible({ status: false, index: 4 });
    getPDCList();
  };

  const onUpdatePDC = () => {
    getPDCList();
    setShowAll(true);
    setVisible({ status: false, index: 0 });
  };

  const onCancel = () => {
    setVisible({ status: false, index: 0 });
  };

  const openModalAction = (data) => {
    setPaymentStatusInfo(data);
    setVisible({ status: true, index: 2 });
  };

  useEffect(() => {
    if (paymentStatusInfo?.selectedOption === "history") {
      let payload = {
        iKey: "11",
        width: "80%",
        extraText: "",
        title: "Change History",
        screen: "payment",
      };
      updateState({ modalPayload: { ...payload, ...{ open: true } } });
    }
  }, [paymentStatusInfo?.selectedOption, paymentStatusInfo]);

  // deep clone for pass data to modify Payment

  const canChequeCleared = Boolean(PDCApi?.permissions?.canChequeCleared);
  const canApproveReceipts = Boolean(PDCApi?.permissions?.canApproveReceipts);
  let data = paymentStatusInfo && _.cloneDeep(paymentStatusInfo);
  const isMultiInvoiceReceivePayment =
    Boolean(organization?.enableMultiInvoicesReceiving) &&
    paymentStatusInfo?.selectedOption === "confirm_payment" &&
    receiptsEnabled;

  const popup = [
    {
      title: (
        <Title level={3} className=" mb-0">
          Attachment
        </Title>
      ),
      content: <ViewPayment item={selectedPDCs?.data} onUpdate={onUpdate} />,
      width: 650,
    },
    {
      title: (
        <Title level={3} className=" mb-0">
          Credit Card Payment Request(s)
        </Title>
      ),
      content: <CreditCardRequest showAll={showAll} onUpdate={onUpdatePDC} getAllPayments={getPDCList} />,
      width: 1650,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          {isMultiInvoiceReceivePayment
            ? `Receive Payment - Invoice ${data?.params?.data?.invoiceNumber}`
            : `Edit Invoice ${data?.params?.data?.invoiceNumber}`}
        </Title>
      ),
      content: isMultiInvoiceReceivePayment ? (
        <ReceivePaymentMultiInvoice
          data={data}
          onUpdate={onUpdatePDC}
          onCancel={onCancel}
          organization={organization}
        />
      ) : (
        <ModifyPaymentStatus
          data={data}
          onUpdate={onUpdatePDC}
          onCancel={onCancel}
          getAllPayments={() => {
            getPDCList();
          }}
          organization={organization}
          openModalAction={openModalAction}
          selectedOption={paymentStatusInfo?.selectedOption}
        />
      ),
      width: 900,
      style: { padding: "0px" },
    },
    {
      title: <PopupTitle title="TOR Ledger" />,
      content: <TorLedger invoice={selectedPDCs} />,
      width: 940,
      style: { padding: 0 },
    },
    {
      title: <PopupTitle title="Document" />,
      content: <DocumentViewer documentId={selectedDocumentId} onClose={onClosePrintInvoiceModal} />,
      width: 1200,
      style: { padding: 0 },
    },
    {
      title: (
        <Title level={3} className="mb-0">
          {`Edit Invoice ${data?.params?.data?.invoiceNumber}`}
        </Title>
      ),
      content: (
        <DeferChequeDeposit
          data={data}
          onUpdate={onUpdatePDC}
          onCancel={onCancel}
          getAllPayments={() => {
            getPDCList();
          }}
          openModalAction={openModalAction}
        />
      ),
      width: 850,
      style: { padding: "0px" },
    },
    {
      title: (
        <PopupTitle
          title={
            creditNoteAction === "approveReject"
              ? `Credit Note Approval ${selectedPDCs?.invoiceNumber}`
              : `Apply Credit Note ${selectedPDCs?.invoiceNumber}`
          }
        />
      ),
      content: (
        <ApplyCreditNote
          invoice={selectedPDCs}
          actionType={creditNoteAction}
          onSuccess={() => {
            setVisible({ status: false, index: 6 });
            getPDCList();
          }}
          onClose={() => setVisible({ status: false, index: 6 })}
        />
      ),
      width: 750,
      style: { padding: 0 },
    },
    {
      title: <PopupTitle title={`Select Cheque to Clear ${data?.params?.data?.invoiceNumber}`} />,
      content: (
        <ChequeClearModal
          onSuccess={() => {
            setVisible({ status: false, index: 7 });
            getPDCList();
          }}
          setVisible={setVisible}
          data={data}
        />
      ),
      width: 850,
      style: { padding: 0 },
    },

    {
      title: (
        <PopupTitle
          title={`${recallChequeActionType === "approveReject" ? "Approve/Reject" : ""} Recall Cheque for ${selectedPDCs?.invoiceNumber}`}
        />
      ),
      content: (
        <RecallCheque
          invoice={selectedPDCs}
          actionType={recallChequeActionType}
          onSuccess={() => {
            setVisible({ status: false, index: 8 });
            getPDCList();
          }}
          onClose={() => setVisible({ status: false, index: 8 })}
        />
      ),
      width: "62rem",
      style: { padding: 0 },
    },
    {
      title: <PopupTitle title={`Approve/Reject Receipt for ${data?.params?.data?.invoiceNumber}`} />,
      content: (
        <ReceiptConfirmation
          onSuccess={() => {
            setVisible({ status: false, index: 9 });
            getPDCList();
          }}
          setVisible={setVisible}
          data={data}
        />
      ),
      width: "65rem",
      style: { padding: 0 },
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible.status,
    title: popup[visible.index].title,
    content: popup[visible.index].content,
    width: popup[visible.index].width,
    style: popup[visible.index]?.style,
    onCancel: () => {
      setVisible({ status: false, index: 0 });
      setSelectedPDC(null);
      setShowAll(true);
      setPendingSendInvoices([]);
      setSendInvoicesModalOpen(false);
      navigate("/invoicing");
      setSelectedDocumentId(null);
    },
  };

  const downloadAction = () => {
    getPdcData(true);
  };

  const handleOwnerSelect = (selectedValue: any, selectedOption?: any) => {
    setSelectedPdcIds([]);
    setResetOwner(null);

    const resolveOwnerId = (): string | undefined =>
      selectedOption?.a ??
      ownerFilterOptions[0]?.options.find((opt: OwnerSelectOption) => opt.value === selectedValue)?.a;

    if (selectedValue === "All Owners" || selectedValue === undefined || selectedValue === "") {
      setOwnerId("");

      return;
    }

    const id = resolveOwnerId();
    if (!id) return;
    setOwnerId(id);
  };

  const resetAllFilters = () => {
    setSelectedUnit(null);
    setSelectedProperty(null);
    setOwnerId("");
    setResetOwner("reset");
    setChequeDateFrom(null);
    setChequeDateTo(null);
    setBankRefFilter(null);
    setTenantNameFilter(null);
    setPaymentRefFilter(null);
    setErpInvoiceNumberFilter(null);
    setErpTenantIdFilter(null);
    setErpReceiptsFilter(null);
    setDateTo(null);
    setDateFrom(null);
    setStatus("all");
    setPaymentType(null);
    setPaymentMode(null);
    setUpdateValue([
      { label: "usageType", value: defaultUsageType },
      { label: "sendStatus", value: defaultSendStatus },
      { label: "property", value: "" },
      { label: "unit", value: "" },
      { label: "status", value: "all" },
      { label: "Payment Mode", value: "all" },
      { label: "Payment Type", value: "all" },
    ]);
    setSelectedUsageType(defaultUsageType);
    setSelectedSendStatus(defaultSendStatus);
    setSelectedPdcIds([]);
    setInvoiceNumber(null);
    setReceiptNoFilter(null);
    setIsCleared(null);
  };

  const PendingRequest = () => (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
      {pendingCreditCardRecordsCount > 0 && (
        <Button danger onClick={() => setVisible({ status: true, index: 1 })} style={{ borderRadius: 24 }}>
          {pendingCreditCardRecordsCount} Credit Card Pending Requests
        </Button>
      )}

      {paymentId && (
        <Button
          danger
          onClick={() => togglePendingRequestsFilter()}
          style={{
            backgroundColor: isPendingRequestsFilter ? "var(--red-100)" : null,
            border: isPendingRequestsFilter ? "1px solid var(--red-100)" : null,
            color: isPendingRequestsFilter ? "red" : "var(--red-300)",
            borderRadius: 24,
          }}
        >
          {pendingApprovalRecordsCount} Pending Requests
          {isPendingRequestsFilter && <CloseCircleOutlined />}
        </Button>
      )}
    </div>
  );

  return (
    <>
      <DashboardLayout load={isPendingGenerateTorRequest}>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <SectionHeader
                  heading="Invoicing"
                  total={PDCApi?.totalCount}
                  headTopLeftText={(paymentId || pendingCreditCardRecordsCount > 0) && <PendingRequest />}
                  viewOption={propertyOptions}
                  justifyStart={true}
                  updateValue={updateValue}
                  handleView={handlePropertyChange}
                  noBorder={true}
                  downloadAction={downloadAction}
                  setDateTo={setDateTo}
                  dateTo={dateTo}
                  setDateFrom={setDateFrom}
                  dateFrom={dateFrom}
                  setDrawer={setDrawer}
                  currentScreen={"payment"}
                  additionalFilters={true}
                  actionButtons={
                    selectedPdcIds.length > 0 ? (
                      <AppButton
                        type="primary"
                        htmlType="button"
                        size="large"
                        style={{ marginTop: 5.4 }}
                        onClick={() => {
                          const list = (PDCApi?.data ?? []) as PdcListRow[];
                          const rows = list.filter((r) => selectedPdcIds.includes(rowPdcId(r)));
                          setPendingSendInvoices(rows);
                          setSendInvoicesModalOpen(true);
                        }}
                      >
                        Send Invoices
                      </AppButton>
                    ) : null
                  }
                />
              </Col>

              {
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      width: "100%",
                      marginInline: "0.75rem",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Pagination
                        className="ag-property-text-pagination"
                        total={PDCApi?.totalCount || 0}
                        showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Invoices`}
                        defaultCurrent={1}
                        pageSize={PDCApi?.perPage || 10}
                        showSizeChanger={false}
                        current={page}
                        onChange={(e) => handlePagination(e)}
                      />
                    </div>

                    <DragAndDropList
                      columns={paymentColumns}
                      setModifiedColumns={setPaymentsColumns}
                      changePicker={setDetectColumnChanges}
                      detectColumnChanges={detectColumnChanges}
                      screenName="payment"
                      hiddenFields={["invoiceNumber"]}
                      setGridReset={setGridReset}
                    />
                  </div>

                  <Col span={24}>
                    <Row gutter={[24, 24]} justify="end">
                      <Col span={24}>
                        <Card bordered={false} className="ag-nospace-body">
                          {isLoading ? (
                            <Loader />
                          ) : (
                            <Grid
                              rowSelection="multiple"
                              data={PDCApi?.data ? PDCApi?.data : []}
                              columns={pdcColumn(
                                gracePeriodDays,
                                paymentModeOptions,
                                setPaymentStatusInfo,
                                setVisible,
                                setSelectedPDC,
                                setCreditNoteAction,
                                paymentColumns,
                                openPrintInvoiceModal,
                                onClickGenerateInvoiceOrTor,
                                onClickRejectTransfer,
                                organization,
                                canChequeCleared,
                                canApproveReceipts,
                                setRecallChequeActionType,
                              )}
                              pagination={false}
                              defaultSettings={defaultSettings}
                              onCellValueChanged={onUpdateCheckStatus}
                              onSelectionChanged={onSelectionChanged}
                              noRowlabel="Invoices"
                              fullPage={true}
                              overlayNoRowsTemplate={"Invoices data cannot be found."}
                            />
                          )}
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </>
              }
            </Row>
          </Col>
          {
            <SideDrawer
              openDrawer={drawer}
              closeDrawer={setDrawer}
              width={screenSize === "xl" ? "410px" : "370px"}
              title={"More Search Options"}
              mask={false}
              placement="right"
            >
              <AdditionalFilters
                dateTo={dateTo}
                dateFrom={dateFrom}
                setDateTo={setDateTo}
                setDateFrom={setDateFrom}
                setChequeDateFrom={setChequeDateFrom}
                setChequeDateTo={setChequeDateTo}
                setPaymentRefFilter={setPaymentRefFilter}
                setTenantNameFilter={setTenantNameFilter}
                setBankRefFilter={setBankRefFilter}
                setErpInvoiceNumberFilter={setErpInvoiceNumberFilter}
                setErpTenantIdFilter={setErpTenantIdFilter}
                setErpReceiptsFilter={setErpReceiptsFilter}
                filterReset={resetAllFilters}
                chequeDateFrom={chequeDateFrom}
                setInvoiceNumber={setInvoiceNumber}
                setReceiptNoFilter={setReceiptNoFilter}
                chequeDateTo={chequeDateTo}
                onAfterFilterSubmit={() => setSelectedPdcIds([])}
                ownerFilterOptions={ownerFilterOptions}
                setIsCleared={setIsCleared}
                onOwnerSelect={handleOwnerSelect}
                isCleared={isCleared}
                resetOwner={resetOwner}
                isReceiptsModuleEnabled={receiptsEnabled}
                ownerFilterOption={(inputValue: string, option: any) => {
                  if (!inputValue || inputValue === "All Owners") {
                    return true;
                  }
                  const options = ownerFilterOptions[0]?.options ?? [];
                  const isExactOwnerSelection = options.some(
                    (opt) => opt.label === inputValue && opt.value !== "All Owners",
                  );
                  if (isExactOwnerSelection) {
                    return true;
                  }
                  return option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
                }}
              />
            </SideDrawer>
          }
        </Row>
        {paymentStatusInfo && paymentStatusInfo?.selectedOption === "history" && (
          <Modal
            className="bd-modal"
            modalPayload={modalPayload}
            updateState={updateState}
            historyData={paymentStatusInfo?.params?.data?.statusHistory}
          />
        )}
      </DashboardLayout>
      <Popup destroyOnClose={true} {...popupProps} />
      <Popup
        destroyOnClose={true}
        closable={true}
        visibility={sendInvoicesModalOpen}
        title={<PopupTitle title="Send Invoices" />}
        content={
          <SendInvoicesConfirm
            invoices={pendingSendInvoices}
            onConfirm={(pdcIds) => sendInvoiceRequest(pdcIds)}
            onClose={() => {
              setPendingSendInvoices([]);
              setSendInvoicesModalOpen(false);
            }}
            isLoading={isPendingSendInvoiceRequest}
          />
        }
        width="62rem"
        style={{ padding: 0 }}
        onCancel={() => {
          setPendingSendInvoices([]);
          setSendInvoicesModalOpen(false);
        }}
      />
    </>
  );
});
